export default {
  getError500: state => state
};